<template>
  <form>
    <v-text-field
        label="Email title"
        v-model="emailTitle"
        outlined
        shaped
    />
    <div class="message-form">
      <v-textarea
          class="message-form__textarea"
          label="Email text"
          v-model="emailText"
          no-resize
          outlined
          rows="3"
          row-height="25"
          shaped
          counter
      />
      <v-btn
          @click="sendEmail"
          :disabled="emailText.trim() === ''"
          class="message-form__button"
          large
          outlined
          color="primary"
      >
        Send email
      </v-btn>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "EmailForm",
  data() {
    return {
      emailTitle: "",
      emailText: "",
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    ...mapMutations({
      createEmails: "emails/CREATE_EMAIL",
    }),
    sendEmail() {
      if (this.emailText.trim() !== "") {
        this.$axios
          .post(`mail/${this.lead.id}/${this.user.id}/send`, {
            emailClient: this.lead.email,
            fullnameClient: this.lead.fullname,
            title: this.emailTitle,
            text: this.emailText,
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
            this.createEmails(res.data.email);
            this.emailText = "";
          })
          .catch((e) => {
            this.showHandlerSnackbar({
              color: e.response.data.status,
              text: e.response.data.message,
              show: true,
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      user: "auth/user",
    }),
  },
};
</script>
